import { EntityType } from '@frontend/common';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { EquipmentClient } from '@frontend/equipment/api';
import { IEquipment } from '@frontend/equipment/types';
import { CommonMessage } from '@frontend/lang';

import { useAppDispatch } from '../../../redux/store';

interface ItemsProps {
    entity_id: string;
}

export const Items = (props: ItemsProps) => {
    const dispatch = useAppDispatch();
    return (
        <ReactiveObjectList<IEquipment>
            label={<span className='capitalize'>{CommonMessage.OBJECTS.TRANSACTION.ITEMS}</span>}
            fetch={(args) => EquipmentClient.fetchEquipments({ ...args, user_id: props.entity_id })}
            columns={{
                columns: ['id', 'product_id'],
                showIdAsEntity: EntityType.EQUIPMENT,
                headerOverwrite: new Map([
                    ['id', <>ID</>],
                    ['product_id', CommonMessage.OBJECTS.PRODUCT.DEFAULT]
                ])
            }}
            dispatch={dispatch}
            type={EntityType.EQUIPMENT}
            tableProps={{ hideFooter: true, maxHeight: true }}
        />
    );
};
